import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';

type Props = {
  param: number;
  sectionTypeDerived: string;
  ratingIndex: number;
  providerId: string;
  healthGradeRating: string;
  'data-testid'?: string;
};

export const StarRating = ({ param, healthGradeRating }: Props) => {
  const ratingAsInt = parseInt(healthGradeRating, 10);
  return (
    <span aria-hidden="true" key={param}>
      <IconSymbol
        css={{
          'abyss-icon': {
            position: 'relative',
            top: param < ratingAsInt ? '0px' : '1px',
            color: param < ratingAsInt ? '$core.color.yellow.100' : 'black',
            stroke: param < ratingAsInt ? '$starBorder' : '',
            strokeWidth: param < ratingAsInt ? '2.5px' : '1px',
          },
        }}
        icon={param < ratingAsInt ? 'star_rate' : 'star_border'}
        size={param < ratingAsInt ? '16px' : '16px'}
      />
    </span>
  );
};
